export default {
	title: 'presence_led_settings',
	component: 'presence_led_settings',
};
